import Accomodations from '~/js/views/resorts/components/Accomodations';

import '~/js/views/resorts/includes/scroll-below';

const internals = {
    filters: {
        roomCategories: ['RP', 'RD']
    }
};

const reactAccomodations = document.querySelector('#rct-accomodations');

ReactDOM.render(<Accomodations filters={internals.filters} />, reactAccomodations);
